<p-card header="Exportação dos textos dos arquivos">

  <div class="p-fluid">
    <div class="p-grid">
      <div class="p-col-18 p-lg-2">
        <label for="ids">Arquivo Ids:</label><br/>
        <span style="font-size: 0.9em">
          Ex: id1,id2,id3<br/>
        </span>
      </div>
      <div class="p-col-12 p-lg-10">
        <textarea pInputTextarea name="ids" rows="10"  [(ngModel)]="ids" style="min-height: 21rem;"></textarea>
      </div>
    </div>
  </div>

  <p-footer>
      <div class="p-fluid">
        <div class="p-grid">
      <button pButton type="button" icon="pi pi-download" (click)="exportarTextos()" label="Exportar textos" class="p-button-info" style="width: 96.3%; left: 17px;"></button>
    </div>
  </div>
  </p-footer>
</p-card>










